import axios from "axios";
import { UploadImportFileRequest } from "../../../types/interfaces/file/imports";
import { UploadMeasurementsResponse } from "../../../types/interfaces/file/imports/flowTestMeasurements";
import { SessionStore } from "../../../types/store/SessionStore";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/flow-tests`;

export const uploadMeasurementsFile = async (
  flowTestId: number,
  uploadInfo: UploadImportFileRequest,
): Promise<UploadMeasurementsResponse> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const formData = new FormData();
  formData.append("measurementXLSX", uploadInfo.file);

  const res = await axios.post<UploadMeasurementsResponse>(
    `${BASE_URL}/${flowTestId}/measurements/upload/validate`,
    formData,
    {
      headers: {
        "content-type": "multipart/form-data",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
